import React from 'react'

const AzimEmoji2Svg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12.8 12.8'
    >
      <g id='emoji-smile-beam-svgrepo-com' transform='translate(-4.6 -4.6)'>
        <path
          id='Path_3141'
          data-name='Path 3141'
          d='M9,14a2.3,2.3,0,0,0,.659.93,2.545,2.545,0,0,0,3.244.024,2.308,2.308,0,0,0,.674-.92'
          transform='translate(-0.289 -1.144)'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='0.8'
        />
        <path
          id='Path_3142'
          data-name='Path 3142'
          d='M17,11a6,6,0,1,1-1.757-4.243A6,6,0,0,1,17,11Z'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='0.8'
          fillRule='evenodd'
        />
        <path
          id='Path_3143'
          data-name='Path 3143'
          d='M13,9.674a.834.834,0,0,0,1.526,0'
          transform='translate(-1.017 -0.646)'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeWidth='0.8'
        />
        <path
          id='Path_3144'
          data-name='Path 3144'
          d='M9,9.674a.834.834,0,0,0,1.526,0'
          transform='translate(-0.509 -0.646)'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeWidth='0.8'
        />
      </g>
    </svg>
  )
}

export default AzimEmoji2Svg
